import React from "react";
import { fileUrl } from "../lib/api";
import { Hammer } from "lucide-react";

export function Photo({ src, className = "", alt = "product" }) {
  const url = fileUrl(src);
  if (!url) {
    return (
      <div className={`flex items-center justify-center bg-[#F1ECE6] ${className}`}>
        <Hammer className="h-8 w-8 text-[#C86D51]/50" />
      </div>
    );
  }
  return <img src={url} alt={alt} className={`object-cover ${className}`} loading="lazy" />;
}

export function ProgressBar({ completed, total, testid = "job-progress-bar" }) {
  const pct = total > 0 ? Math.min(100, Math.round((completed / total) * 100)) : 0;
  return (
    <div data-testid={testid} className="w-full">
      <div className="flex justify-between items-baseline mb-1.5">
        <span className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Progress</span>
        <span className="tnum text-sm font-bold text-[#9A462B]">{pct}%</span>
      </div>
      <div className="h-3 w-full rounded-full bg-slate-200 overflow-hidden">
        <div className="h-full rounded-full copper-gradient transition-all duration-500" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
